/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_CreatedInputs */

const en_sort_created = /** @type {(inputs: Sort_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_sort_created = /** @type {(inputs: Sort_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Sort_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_created = /** @type {((inputs?: Sort_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_created(inputs)
	return en_sort_created(inputs)
});